import React from 'react';
import PropTypes from 'prop-types';
import logoLong from '@assets/images/logo_and_name.png';

SignupBanner.propTypes = {
  headline: PropTypes.node,
  body: PropTypes.node,
  className: PropTypes.string,
};

/**
 * The marketing banner shown at the top of the unauthenticated signup-adjacent
 * pages. Displays the CommunityShare wordmark on a navy field with an optional
 * headline and body.
 *
 * @param {object} props - Component props.
 * @returns {JSX.Element} The rendered banner.
 */
export default function SignupBanner(props) {
  const { headline, body, className = '' } = props;

  return (
    <div className={`w-full bg-cs-navy-600 px-4 py-10 md:p-10 ${className}`}>
      <div className="flex flex-col gap-3 w-full max-w-screen-xl mx-auto">
        <div className="flex flex-col gap-6">
          <img
            src={logoLong}
            alt="CommunityShare"
            className="h-13 w-auto object-contain self-start"
          />
          {headline && (
            <h2 className="text-4xl font-semibold text-white leading-[1.3]">
              {headline}
            </h2>
          )}
        </div>
        {body && <p className="text-base text-white leading-normal">{body}</p>}
      </div>
    </div>
  );
}
